import React, {useEffect} from 'react';
import {Helmet} from "react-helmet-async";
import AboutUsContent from './AboutUsContent';
import VidyaJyotiBanner from '../VidyaJyotiBanner';

export default function AboutUsMain() {
   useEffect(()=>{
      window.scrollTo(0,0)
      },[])
  return (
    <div>
      <Helmet>
        <title>About Us - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies</title>
        <meta name="description" content="About Us - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" />
        <meta name="keywords" content="About Us - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" />
        <link rel="canonical" href="/about" />
      </Helmet>
      {/*<AboutUsHeader />
      <NewFaceView />*/}
      <VidyaJyotiBanner />
      <AboutUsContent />
    </div>
  )
}
